// extracted by mini-css-extract-plugin
module.exports = {"departments":"Hh","departmentHeading":"Ih","departmentSection":"Jh","departmentName":"Kh","departmentLink":"Lh","expandIcon":"Mh"};